/**
 * useAgo — 지난 시각을 "방금 전" / "3분 전" / "2시간 전"으로, 30초마다 다시 계산한다(2026-10-23).
 * 자동 조회가 멈춰도 숫자가 늘어나 오래된 자료가 저절로 드러난다. at 이 null 이면 "".
 */
import { useEffect, useState } from "react";
import { fmtAgo } from "@/lib/format";

const TICK_MS = 30_000;

export function useAgo(at: Date | null): string {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (!at) return;
    const id = window.setInterval(() => setNow(Date.now()), TICK_MS);
    return () => window.clearInterval(id);
  }, [at]);
  return at ? fmtAgo(at, now) : "";
}
